export const protocol = 'https'

export const host = 'api.propertise.com'
// export const host = "192.168.29.136";
export const port = ''
export const trailUrl = ''
